/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */

import React, { useCallback, useEffect } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";

export default function AppDropdown({
  data = [],
  filterable = false,
  ref = null,
  ...restProps // everything else (e.g. style, className, etc.)
}) {
  const [filteredData, setFilteredData] = React.useState(data);

  const handleFilterChange = (event) => {
    setFilteredData(filterBy(data, event.filter));
  };

  useEffect(() => {
    setFilteredData(data);
  }, [data]);
  return (
    <DropDownList
      ref={ref}
      filterable={filterable}
      {...restProps}
      onFilterChange={handleFilterChange}
      data={filteredData || []}
    />
  );
}
